<template>
  <b-col md="12">
    <section class="accommodations">
      <card-recap :show_header="false" :show_footer="false" :show_matching="true" :property_data="solution.property" />
    </section>
  </b-col>
</template>

<script>
import CardRecap from "@liveeps/components/blocks/card-recap.vue"

export default {
  inheritAttrs: false,
  name: 'accommodations',

  components: {
    'card-recap': CardRecap,
  },

  props: {
    solution: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .accommodations {
    margin-top: $grid-gutter-width;
  }

  ::v-deep {
    .recap__room-title {
      font-size: $font-size-lg;
    }
  }

</style>